<div class="container">
    <div class="row mt-4" [formGroup]="form">
        <div class="col-12">
            <h4>{{formDTO.name}} - Cadastrar Fórmula</h4>
        </div>
        <div class="col-12">
            <hr>
        </div>
        <div class="col-12">
            <label for="">Nome</label>
            <input type="text" class="form-control" formControlName="name">
        </div>
        <div class="col-12 mt-2">
            <label for="">Etiqueta</label><br>
            <div class="form-check form-check-inline" *ngFor="let item of listTypeFormule">
                <input class="form-check-input" [checked]="item.checked" type="checkbox" id="{{item.name}}" value="{{item.id}}" (click)="chooseType(item.id)">
                <label class="form-check-label" for="{{item.name}}">{{item.name}}</label>
              </div>
        </div>
        <div class="col-12 mt-2">
            <label for="">Descrição</label>            
            <ckeditor data="{{formuleDTO.description}}" formControlName="description"></ckeditor>
        </div>

        <div class="col-6 mt-4 text-left">
            <button class="btn btn-secondary col-6" (click)="backListFormule()">Voltar</button>
        </div>
        <div class="col-6 mt-4 text-right">
            <button class="btn btn-success col-6" (click)="saveOrEdit()">Gravar</button>
        </div>

    </div>
</div>